import { RadioCard, RadioGroupField } from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { Field } from "formik";
import { Trans } from "react-i18next";

type SexCheckField = components["schemas"]["SexCheckField"];

export function SexInputField({ field: config }: { field: SexCheckField }) {
  return (
    <>
      <Field
        direction="column"
        as={RadioGroupField}
        name={config.name}
        isRequired
        aria-label={config.name + " radio button selections"}
        testID="sex-radio-group"
      >
        <RadioCard testID="sex-section-male-radio-button" value="M">
          <Trans>Male</Trans>
        </RadioCard>
        <RadioCard testID="sex-section-female-radio-button" value="F">
          <Trans>Female</Trans>
        </RadioCard>
        <RadioCard testID="sex-section-x-radio-button" value="X">
          <Trans>X</Trans>
        </RadioCard>
      </Field>
    </>
  );
}
